export default class Stretch {
  id: number
  name: string
  code: string
  origin: string
  destination: string
  // tslint:disable-next-line:variable-name
  operationLine_id: string | number
  description?: string
  prices: any[] = []
  timeCancel: number
  timeExpiration: number
  icon: string
  tramoHora: boolean
  hours: number
  minutes: number
  hora: {hours: number, minutes: number}

  constructor(props: Stretch) {
    console.log('Stretch - constructor - props: ', props)
    Object.assign(this, props)
    this.hora = {hours: props.hours, minutes: props.minutes}
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Stretches/Model.ts